import { NgModule } from '@angular/core';
import { EditUserNameComponent } from './edit-user-name.component';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '@shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [EditUserNameComponent],
  imports: [
    CommonModule,
    MatDialogCustomModule,
    MatInputModule,
    SharedModule,
    MatProgressSpinnerModule,
    TranslateModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [EditUserNameComponent],
})
export class EditUserNameModule {}
